import getCookieValue from './getCookieValue';
import isCztCookie from './isCztCookie';

export default function(cookieName: string, cookiesString: string): boolean {
  const value = getCookieValue(cookieName, cookiesString);
  return value && isCztCookie(value) ? true : false;
}
